import { useEffect, useId, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera, faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";
import styles from "./Wardrobe.module.css";
import { CATEGORIES, imageUrl } from "./wardrobeConstants";
import ImagePicker from "../../components/imagePicker/ImagePicker";
import { toast } from "react-toastify";

const EMPTY = {
  name: "", category: "", subcategory: "", color: "", pattern: "",
  material: "", brand: "", description: "", image_url: "",
};

function ClothingItemForm({ item, saving, onClose, onSave }) {
  const titleId = useId();
  const [values, setValues] = useState(() => ({ ...EMPTY, ...item }));
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(item?.image_url ? imageUrl(item.image_url) : "");
  const [removeImage, setRemoveImage] = useState(false);

  useEffect(() => () => {
    if (preview?.startsWith("blob:")) URL.revokeObjectURL(preview);
  }, [preview]);

  useEffect(() => {
    const closeOnEscape = (event) => event.key === "Escape" && !saving && onClose();
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [onClose, saving]);

  const change = ({ target }) => setValues((current) => ({
    ...current, [target.name]: target.value,
  }));

  const selectImage = (nextFile, normalized) => {
    setFile(nextFile);
    setRemoveImage(false);
    setPreview(normalized.previewUrl);
  };

  const clearImage = () => {
    setFile(null);
    setPreview("");
    setRemoveImage(Boolean(item?.image_url));
  };

  const submit = (event) => {
    event.preventDefault();
    const data = new FormData();
    Object.entries(values).forEach(([key, value]) => {
      if (key !== "image_url" && value !== null && value !== undefined) data.append(key, value);
    });
    if (file) data.append("image", file);
    if (removeImage) data.append("image_url", "");
    if (!item) data.append("source_type", "manual");
    onSave(data);
  };

  return (
    <div className={styles.backdrop} role="presentation" onMouseDown={(event) => {
      if (event.target === event.currentTarget && !saving) onClose();
    }}>
      <section className={styles.formModal} role="dialog" aria-modal="true" aria-labelledby={titleId}>
        <header className={styles.modalHeader}>
          <div><p className={styles.eyebrow}>Meu Guarda-Roupa</p><h2 id={titleId}>{item ? "Editar peça" : "Adicionar peça"}</h2></div>
          <button type="button" className={styles.iconButton} onClick={onClose} disabled={saving} aria-label="Fechar"><FontAwesomeIcon icon={faXmark} /></button>
        </header>
        <form onSubmit={submit} className={styles.form}>
          <div className={styles.imageField}>
            {preview ? <img src={preview} alt="Prévia da peça selecionada" /> : <span><FontAwesomeIcon icon={faCamera} /><small>Adicione uma foto da peça</small></span>}
            <div className={styles.imageActions}>
              <ImagePicker label={preview ? "Trocar imagem" : "Escolher imagem"} onSelect={selectImage} disabled={saving} onError={toast.error} />
              {preview && <button type="button" className={styles.removeImage} onClick={clearImage} disabled={saving}><FontAwesomeIcon icon={faTrash} /> Remover</button>}
            </div>
            <small>JPEG, PNG ou WebP, até 5 MB.</small>
          </div>
          <div className={styles.fields}>
            <label>Nome *<input name="name" value={values.name} onChange={change} required maxLength="120" /></label>
            <label>Categoria *<select name="category" value={values.category} onChange={change} required><option value="">Selecione</option>{CATEGORIES.map(([value, label]) => <option key={value} value={value}>{label}</option>)}</select></label>
            <label>Subcategoria<input name="subcategory" value={values.subcategory || ""} onChange={change} maxLength="60" /></label>
            <label>Cor<input name="color" value={values.color || ""} onChange={change} maxLength="60" /></label>
            <label>Estampa<input name="pattern" value={values.pattern || ""} onChange={change} maxLength="60" /></label>
            <label>Material<input name="material" value={values.material || ""} onChange={change} maxLength="80" /></label>
            <label>Marca<input name="brand" value={values.brand || ""} onChange={change} maxLength="100" /></label>
            <label className={styles.fullField}>Descrição<textarea name="description" value={values.description || ""} onChange={change} maxLength="2000" rows="4" /></label>
          </div>
          <footer className={styles.formActions}><button type="button" className={styles.secondaryButton} onClick={onClose} disabled={saving}>Cancelar</button><button type="submit" disabled={saving}>{saving ? "Salvando..." : item ? "Salvar alterações" : "Adicionar peça"}</button></footer>
        </form>
      </section>
    </div>
  );
}

export default ClothingItemForm;
